import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import initialState from "reducers/initialState";

const financialDataSummaryReducer = (state = initialState.currentOffer.financialDataSummary, action) => {
  switch (action.type) {
    case actionTypes.LOAD_FINANCIAL_DATA_SUMMARY_STARTED: {
      return {
        ...state,
        loading: true
      };
    }
    case actionTypes.LOAD_FINANCIAL_DATA_SUMMARY_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        loading: false,
        loaded: true
      };
    }
    case actionTypes.LOAD_FINANCIAL_DATA_SUMMARY_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: false
      };
    }

    case eventTypes.FINANCIAL_DATA_SUMMARY_INVALIDATED: {
      return { loaded: false, loading: false };
    }
    default:
      return state;
  }
};
export default financialDataSummaryReducer;
